import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import firebaseApp from "services/firebase";

/**
 * Product flag: when true, patient sign-in can opt into shared/public-computer
 * behavior (SESSION auth persistence, idle sign-out, and device-trace wipe on logout).
 * Flip to false to disable the feature without removing call sites.
 */
export const PUBLIC_COMPUTER_MODE_ENABLED = true;

/** sessionStorage key for the current-tab public-computer choice. */
export const PUBLIC_COMPUTER_STORAGE_KEY = "asi_public_computer";

/**
 * @returns {boolean}
 */
export function isPublicComputer() {
  if (!PUBLIC_COMPUTER_MODE_ENABLED) return false;
  try {
    return window.sessionStorage.getItem(PUBLIC_COMPUTER_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * @param {boolean} enabled
 */
export function setPublicComputer(enabled) {
  try {
    if (enabled) {
      window.sessionStorage.setItem(PUBLIC_COMPUTER_STORAGE_KEY, "1");
    } else {
      window.sessionStorage.removeItem(PUBLIC_COMPUTER_STORAGE_KEY);
    }
  } catch {
    // sessionStorage may be unavailable (private mode / quota).
  }
}

/**
 * Apply Firebase Auth persistence for the "shared or public computer" choice.
 * SESSION ends when the browser tab/window is closed; LOCAL survives reopen.
 * When shared/public is true, also sets the session flag used by idle sign-out
 * and logout wipe.
 *
 * @param {boolean} sharedOrPublicComputer
 * @returns {Promise<void>}
 */
export async function applyPublicComputerPersistence(sharedOrPublicComputer) {
  const persistence = sharedOrPublicComputer
    ? firebase.auth.Auth.Persistence.SESSION
    : firebase.auth.Auth.Persistence.LOCAL;
  await firebaseApp.auth().setPersistence(persistence);
  setPublicComputer(!!sharedOrPublicComputer);
}
